import styles from "../../BorrowerDetails.module.css";
import Pdf from "../../../../../assets/PDF_file_icon 4.svg";
import { useBorrowerContext } from "../../store/borrower-details";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import PDFViewer from "../PDFViewer/PDFViewer";
import EnlargeDocModal from "./EnlargeDocModal";
import { useParams } from "react-router";

const SingleDocModal = ({
  title,
  closeModal,
  docType,
  doc,
  download,
  delete: deleteDoc,
  isDownload,
  isDelete
}) => {
  console.log(download, deleteDoc)
  const [pdfModal, setPdfModal] = useState({
    open: false,
    data: "",
  });
  const { borrowerData } = useBorrowerContext();
  const [enlargeImg, setEnlargeImg] = useState(false);
  const { loanid } = useParams();
  const fetchedLoanDetails = borrowerData.loan;
  const foundLoan = fetchedLoanDetails.find((item) => item.loan_id === loanid);

  const viewPdfHandler = (url) => {
    setPdfModal((prevState) => ({
      ...prevState,
      open: true,
      data: `data:application/pdf;base64,${url}`,
    }));
  };

  const closePdfViewer = () => {
    setPdfModal((prevState) => ({
      ...prevState,
      open: false,
      data: "",
    }));
  };

  const enlargeImageHandler = () => {
    setEnlargeImg(true);
  };

  const closeEnlargeModal = () => {
    setEnlargeImg(false);
  };

  const { contextMenuHandler } = useBorrowerContext();
  return (
    <>
      {enlargeImg && (
        <EnlargeDocModal
          doc={doc}
          docType={docType}
          closeModal={closeEnlargeModal}
          borrowerDetails={borrowerData}
          loanDetails={foundLoan}
        />
      )}
      {pdfModal.open && (
        <PDFViewer url={pdfModal.data} closeModal={closePdfViewer} />
      )}
      <div className={styles.borrowerDocumentsModal}>
        <div
          className={styles.borrowerDocumentsModaOverlay}
          onClick={(e) => e.target === e.currentTarget && closeModal()}
        >
          <div
            className={styles.borrowerDocumentsModalContent}
            onContextMenu={contextMenuHandler}
          >
            <h3>{title}</h3>
            <CloseIcon className={styles.CloseIcon} onClick={closeModal} />
            {/* <div className={styles.rotateIcon}>
              <RotateRightIcon onClick={rotateHandler} titleAccess="Rotate" />
            </div> */}
            {docType === "xml" ? (
              <div>
                <section>
                  <h1>XML</h1>
                </section>
                <div>
                  <button onClick={download}>Download</button>
                  {isDelete && foundLoan?.loan_status !== "DISBURSED" && (
                    <button
                      style={{ backgroundColor: "red", marginTop: "1vh" }}
                      onClick={deleteDoc}
                    >
                      Delete
                    </button>
                  )}
                </div>
              </div>
            ) : docType !== "pdf" ? (
              <div>
                <div>
                  <img
                    draggable={false}
                    src={`data:image/${docType};base64,${doc}`}
                    onClick={enlargeImageHandler}
                    alt="loading"
                  />
                </div>
                <div>
                  {isDownload && <button onClick={download}>Download</button>}
                </div>
                <div>
                  {isDelete && foundLoan?.loan_status !== "DISBURSED" && (
                    <button
                      style={{ backgroundColor: "red", marginTop: "1vh" }}
                      onClick={deleteDoc}
                    >
                      Delete
                    </button>
                  )}
                </div>
              </div>
            ) : (
              <div>
                <section>
                  <img
                    src={Pdf}
                    alt=""
                    className={styles.docsPDF}
                    onClick={() => viewPdfHandler(doc)}
                  />
                </section>
                <div>
                  <button onClick={download}>Download</button>
                  {isDelete && foundLoan?.loan_status !== "DISBURSED" && (
                    <button
                      style={{ backgroundColor: "red", marginTop: "1vh" }}
                      onClick={deleteDoc}
                    >
                      Delete
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleDocModal;
